import { Model } from '@/models/Model';
export class AreaSubject extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'AreaSubject';
        this.$endpoint = '';
    }
    user(user) {
        this.$endpoint = `/users/${user}/relationships/subjects/active`;
        return this;
    }
    group(group) {
        this.$endpoint = `/groups/${group}/relationships/subjects/active`;
        return this;
    }
}
